import {
  GetBillingCouponCheckResult,
  SocialTypeEnum,
} from '@frontend/sorghum/interface';

import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { BILLING_COUPON_CHECK } from '../apis';

interface Props {
  code: string;
  socialType: SocialTypeEnum;
  // 本次要購買的付款週期（1 月繳 / 2 年繳）。折扣碼可限定週期，後端沒收到 period 會 fail-closed，
  // 所以是必填，不給呼叫端漏帶
  period: number;
}

async function getGetBillingCouponCheck({
  code,
  socialType,
  period,
}: Props): Promise<GetBillingCouponCheckResult> {
  // 用 axios params 讓 query 自動 URL-encode：code 是使用者輸入，含 & 或 % 時手動拼字串會截斷或解析失敗
  return axios
    .get(BILLING_COUPON_CHECK, { params: { code, socialType, period } })
    .then((res) => res.data)
    .catch((err) => ({
      code: 400,
      msg: err,
    }));
}

export function useGetBillingCouponCheck() {
  return useMutation({
    mutationKey: ['get-billing-coupon-check'],
    mutationFn: (props: Props) => getGetBillingCouponCheck(props),
  });
}

export default useGetBillingCouponCheck;
